<template>
  <el-form ref="ff" :model="detail">
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="品名" prop="Name" required>
          <el-input v-model="detail.Name" />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="编码">
          <el-input v-model="detail.Code" />
        </el-form-item>
      </el-col>
      <el-col>
        <el-form-item label="规格" prop="Spec" required>
          <el-input v-model="detail.Spec" />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="单价" prop="Price" required>
          <el-input v-model="detail.Price" />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="数量" prop="Quantity" required>
          <el-input v-model="detail.Quantity" />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="单位" prop="Unit" required>
          <el-input v-model="detail.Unit" />
        </el-form-item>
      </el-col>
    </el-row>
    <el-form-item>
      <el-button type="primary" @click="onSubmit">确定</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  data () {
    return {
      detail: {}
    }
  },
  props: {
    callback: { type: Function, default: null },
    layerid: { type: String, default: null }
  },
  methods: {
    onSubmit () {
      this.$refs['ff'].validate(valid => {
        if (valid) {
          typeof this.callback == "function" && this.callback(this.detail)
          this.$layer.close(this.layerid)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>